import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUser } from '../Redux/currentUserSlice';

const ProtectedRoute = ({ children, requiredRole }) => {
  const user = useSelector(selectUser); // Get user from Redux store

  // Redirect if not logged in
  if (!user || !user.token) {
    return <Navigate to="/" />;
  }

  // Check if user has one of the required roles (can be 'super_admin', 'admin', etc.)
  if (!requiredRole.includes(user.role)) {
    return <Navigate to="/" />;
  }

  return children; // Render the protected content
};

export default ProtectedRoute;